document.addEventListener("DOMContentLoaded", function() {
  $(".modal").on("click", ".close", function() {
    $(this).closest(".modal").modal("hide");
  });
});
